module.exports = __webpack_public_path__ + "img/asicd-r6ihj.663c379e.png";